import api from "@/config/axios";
const path = "content/";

function obtenerPopUps() {
  return api.get(path + "getPopUps");
}

function obtenerPrecios() {
  return api.get(path + "getPrices");
}

export { obtenerPopUps, obtenerPrecios };
